import type { SvgPathProps } from '../Icon';

const DataExchange: React.FC<SvgPathProps> = ({ isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <path
      fillRule={'evenodd'}
      d="M6.464 27.741l3.88 3.878-.92.92-4.907-4.906a.652.652 0 010-.92l4.97-4.97.92.92-3.779 3.777h17.237l-3.778-3.778.92-.92 4.906 4.906a.653.653 0 010 .92l-4.97 4.971-.92-.92 3.878-3.878H6.464zm22.214-13.23c-7.82 0-12.813-1.892-12.813-3.194s4.992-3.194 12.813-3.194c7.822 0 12.814 1.892 12.814 3.194s-4.992 3.194-12.814 3.194zm0-7.688c-7.013 0-14.113 1.543-14.113 4.494v13.104h1.3V13.315c2.363 1.644 7.608 2.497 12.813 2.497 5.205 0 10.451-.853 12.814-2.497V38.09c0 1.301-4.992 3.193-12.814 3.193-7.82 0-12.813-1.892-12.813-3.193v-8.23h-1.3v8.23c0 2.95 7.1 4.494 14.113 4.494 7.014 0 14.114-1.544 14.114-4.494V11.317c0-2.95-7.1-4.494-14.114-4.494z"
    />
  );

  const normalHover = (
    <path
      fillRule={'evenodd'}
      d="M4.464 27.741l3.879 3.88-.92.92-4.906-4.908a.65.65 0 010-.92l4.97-4.97.92.92-3.778 3.777h21.236l-3.778-3.778.919-.92 4.907 4.907a.65.65 0 010 .92l-4.971 4.971-.92-.92 3.88-3.879H4.464zm24.214-13.23c-7.821 0-12.813-1.892-12.813-3.194 0-1.303 4.992-3.195 12.813-3.195 7.822 0 12.814 1.892 12.814 3.195 0 1.302-4.992 3.194-12.814 3.194zm0-7.688c-7.013 0-14.113 1.543-14.113 4.494v13.104h1.3V13.315c2.363 1.644 7.609 2.496 12.813 2.496 5.205 0 10.45-.852 12.814-2.496V38.09c0 1.302-4.992 3.194-12.814 3.194-7.821 0-12.813-1.892-12.813-3.194v-8.23h-1.3v8.23c0 2.951 7.1 4.495 14.113 4.495 7.014 0 14.114-1.544 14.114-4.495V11.317c0-2.95-7.1-4.494-14.114-4.494z"
    />
  );

  return isHovered ? normalHover : normal;
};

export default DataExchange;
